import ApiHelper from '../../ApiHelper';
import API_ENDPOINTS from '../../endpoints';

class ChatbotSettingsHelper {
  async getSettings() {
    try {
      const response = await ApiHelper.get(API_ENDPOINTS.ADMIN_CHATBOT.SETTINGS);
      return response;
    } catch (error) {
      throw new Error(`Failed to fetch chatbot settings: ${error.message}`);
    }
  }

  async updateSettings(data) {
    try {
      const response = await ApiHelper.put(API_ENDPOINTS.ADMIN_CHATBOT.SETTINGS, data);
      return response;
    } catch (error) {
      throw new Error(`Failed to update chatbot settings: ${error.message}`);
    }
  }

  async getUsageStats(days = 30) {
    try {
      const response = await ApiHelper.get(
        `${API_ENDPOINTS.ADMIN_CHATBOT.USAGE_STATS}?days=${days}`
      );
      return response;
    } catch (error) {
      throw new Error(`Failed to fetch chatbot usage stats: ${error.message}`);
    }
  }
}

export default new ChatbotSettingsHelper();
